import { render, staticRenderFns } from "./artefact-toolbox.vue?vue&type=template&id=234511ed&scoped=true&"
import script from "./artefact-toolbox.vue?vue&type=script&lang=ts&"
export * from "./artefact-toolbox.vue?vue&type=script&lang=ts&"
import style0 from "./artefact-toolbox.vue?vue&type=style&index=0&id=234511ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234511ed",
  null
  
)

export default component.exports